import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './index.css';

// Stale-chunk recovery: after a deploy, a still-open tab (or one served a cached
// index.html by the service worker) requests lazy chunks whose hashed names no
// longer exist → dynamic import() rejects with `vite:preloadError`, crashing the
// route into the ErrorBoundary. Force one fresh reload (sessionStorage-guarded so
// a genuinely missing asset can't loop) to pull the new index.html + chunks.
window.addEventListener('vite:preloadError', () => {
  if (sessionStorage.getItem('chunk-reloaded')) return;
  sessionStorage.setItem('chunk-reloaded', '1');
  window.location.reload();
});
// Clear the guard once a load actually succeeds so future deploys can recover too.
window.addEventListener('load', () => sessionStorage.removeItem('chunk-reloaded'));

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary scope="root">
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// PWA service worker — runtime caching + offline shell. Skipped in dev.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
